export default {
	"当前存在正在编辑的题目无法创建新题目": 'Cannot create a new question when an existing question is bejing edited',
	"请添加页后再添加题目": 'Please add a page before adding a question',
	"此链接可分享到外部进行测试项目结束后链接自动失效": 'This link can be shared externally for testing and will automatically fail after the project ends',
	"此测试仅针对系统内登录后测试分享如无系统账号无法打开慎用": 'This is only for internal test after login in the system. The sharing link  cannot be opened without a system account. Please use it with caution',
	"确定提交": 'Confirm submission',
	"删除成功": 'Successfully deleted',
	"确定要删除文件": 'Confirm to delete the file',
	"答案必须为数字": 'Answer must be a number',
	"答案不在范围内": 'Answer is not in effective range',
	"最多上传": 'Maximum uploads',
	"个附件": 'attachments',
	"最少上传": 'Minimum uploads',
	"存在未参与排序的选项": 'There are options that do not participate in sorting',
	"最少排": 'Minimum items for ranking',
	"最多只能排": 'Maximum items for ranking',
	"项": ' item',
	"问题半开放未填": 'Semi open question is empty',
	"矩阵半开放未填": 'Semi open in matrix question is empty',
	"选项半开放未填": 'Semi open option is empty',
	"成功": 'Successful',
	"清除成功": 'Cleared successfully',
	"上传成功": 'Uploaded successfully',
	"提交成功": 'Submitted successfully',
	"您有题目未作答请作答后提交": 'You have questions not answered. Please answer all questions before submit them.',
	"该题已作答": 'This question is already answered',
	"最多选择": 'Maximum number for selection',
	"只能上传图片": 'Upload pictures only',
	"只能上传视频": 'Upload videos only',
	"只能上传图片或视频": 'Upload pictures or videos only',
	"上传失败": 'Upload failed',
	"请输入": 'Please enter',
	"请输入手机号": 'Please enter your phone number',
	"手机号有误": 'Wrong phone number',
	"手机号不能为空": 'Phone number cannot be empty',
	"同一个设备只能填一次": 'Answer once only on the same device',
	"请设置题号": 'Please set the question number',
	"请选择题型": 'Multiple choice question',
	"选择题型": 'Type',
	"必填": 'Answer required',
	"配额题": 'Quota question',
	"题目": 'Question',
	"问题描述": 'Question description',
	"请在这里输入": 'Please enter here',
	"请填写题号": 'Please write down question number',
	"题号": 'Qn',
	"请填写题目": 'Please fill in the question',
	"必填项未填": 'Required fields not filled',
	"超出上传文件限制的个数": 'Number of files exceeding the upload limit',
	"上传图片只能是jpg或者png格式": 'Only jpg or png can be uploaded',
	"确定移除": 'Confirm to remove',
	"存在重复的值请修改后提交": 'Duplicate values exist. Please modify before submission.',
	"请选择": 'Please select',
	"不能为空": 'Cannot be empty',
	"请输入随机的选项若勾选全部随机则不需要填写": 'Please enter random options. If All Random is selected, no need to enter.',
	"请输入不随机的选项": 'Please enter a non-random option',
	"请输入行问题的选项若勾选全部随机则不需要填写": 'Please enter options for row question. If All Random is selected, no need to enter.',
	"请输入随机的问题若勾选全部随机则不需要填写": 'Please enter random questions. If all random is selected, you do not need to enter any questions',
	"表示问题随机": 'Indicates that questions with values of 1,2, and 3 are randomized and separated by commas',
	"请输入列随机": 'Please enter random questions. If All Random is selected, no need to enter.',
	"答题时限有误": 'Wrong time limit',
	"请选择量表类型": 'Please select the scale type',
	"请输入类型名称": 'Please enter a type name',
	"请输入选项数量": 'Please enter the number of options',
	"选项数量必须是数字": 'The number of options must be numeric',
	"默认样式最大数量": 'Maximum number of default charts is 10',
	"最大上传数不能小于最小上传数":'The maximum number of uploads cannot be smaller than the minimum number of uploads',
	"值不能为空":'Value cannot be empty',
	"值必须为数字":'Value must be a number',
	"选项不能为空":'Option cannot be empty',
	"问题不能为空":'Question cannot be empty',
	"问卷已发布修改可能造成问卷出错请谨慎操作":'Please be careful. Making changes to the launched questionnaire may cause errors. If you do need to make changes, do not forget to click the Save button after making changes',
	"复制题目错误请重新复制":'Error in copying question. Please copy again',
	"复制成功":'If the copy is successful, you can paste it in Creat a New Question',
	"确认要删除此题":'Are you sure you want to delete this question？',
	"分类名称不能为空":'Category name cannot be empty',
	"添加成功":'Added successfully',
	"请填写划线内容":'Please complete the underlining question',
	"划线内容未填":'Underlined content is not filled in',
	"请选择量表类型":'Please select the scale type',
	"确定删除此页":'Are you sure to delete this page?',
	"这是最后一页了":'This is the last page',
	"该项目已发布如再使用导入可能产生无法挽回的后果":"This project is already launched. If you use Importagain, it may cuase irreversible consequences. Please use with caution! Please click 'Yes' if you really want to import, or click 'No'  to cancel.",
	"是否复制分享链接":'Whether to copy the share link',
	"超出文件上传数量":'The number of files uploaded exceeded the limit',
	"产品至少有一页数据":'The product has at least one page of data',
  "请签名后保存":'Please sign and save',
  "联动选项":'Linkage options',
  "请上传csv格式文件":'Please upload a CSV format file',
  "联动选项未填":'Linkage option not filled in',
	"请勾选":'Please check the box',
  "标注图片未传":'Annotated image not uploaded',
  "示例":'Example'
	
}